/* eslint-disable no-useless-escape */
import axios from "axios";
import * as Constants from "../constants/Constants";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as Helpers from "./Helpers";

const Enum = {
    KEY1: 1,
    KEY2: 2,
    KEY3: 3,
    KEY4: 4,
};

Object.freeze(Enum); //Object.freeze will freeze the object so that no new enum can be added to it.

//MARK: POST methods
export function callApi(username, password, tokenId) {
    // const errorNotify = (message) => {
    //     toast.error(message, {
    //         position: toast.POSITION.BOTTOM_CENTER,
    //         hideProgressBar: true,
    //         autoClose: Constants.errorNotifyDuration
    //     });
    // };

    const params = {
        UserName: username,
        Password: password,
        MobileType: "",
        SessionID: "",
        UserIPAddress: "185.99.34.25",
        TokenID: tokenId,
        HdnKey: "",
        FingerPrintID: "",
        FingerPrintLevel: "",
        RegistrationId: "",
        isAuthorizeOnly: "N",
    };

    axios
        .post(Constants.baseURL + Constants.userAuthintications, params, {
            withCredentials: true,
        })
        .then((response) => {
            return response;
        })
        .catch((error) => {
            //console.log("error", error);
            Helpers.errorNotify(this.props.t(error), this.props.i18n.language);
        });
}

var _keyStr =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
export function authenticate(
    UserName,
    Password,
    MobileType,
    SessionID,
    UserIPAddress,
    TokenID,
    HdnKey,
    FingerPrintID,
    FingerPrintLevel,
    RegistrationId,
    isAuthorizeOnly,
    options
) {
    const params = {
        UserName: encryptedString(UserName),
        Password: encryptedString(Password),
        MobileType: MobileType,
        SessionID: SessionID,
        UserIPAddress: UserIPAddress,
        TokenID: TokenID,
        HdnKey: HdnKey,
        FingerPrintID: FingerPrintID,
        FingerPrintLevel: FingerPrintLevel,
        RegistrationId: RegistrationId,
        isAuthorizeOnly: isAuthorizeOnly,
    };

    //console.log("baseUrl: ", Constants.baseURL)
    return NewHttpPost(
        Constants.baseURL + Constants.userAuthintications,
        params,
        options
    );
}
export function registrationsOTP(
    username,
    tokenID,
    tradingNo,
    password,
    key,
    fingerPrintID,
    isAuthorizeOnly = "N",
    isIPOQuickSell,
    options = { withCredentials: true }
) {
    const params = {
        UserName: username,
        Password: password,
        MobileType: "",
        SessionID: "",
        UserIPAddress: "127.0.0.1",
        TokenID: tokenID,
        TradingNo: tradingNo,
        HdnKey: key,
        FingerPrintID: fingerPrintID,
        FingerPrintEnabled: "N",
        isAuthorizeOnly: isAuthorizeOnly,
        isIPOQuickSell: isIPOQuickSell
    };
    return NewHttpPost(
        Constants.baseURL + Constants.registrationsOTP,
        params,
        options
    );
}

export function userAuthinticationAdvance(
    MobileType,
    UserIPAddress,
    NIN,
    ID,
    Mobile,
    Email,
    RequestType,
    options = { withCredentials: true }
) {
    const params = {
        MobileType: MobileType,
        UserIPAddress: UserIPAddress,
        NIN: NIN,
        ID: ID,
        Mobile: Mobile,
        Email: Email,
        RequestType: RequestType,
    };
    return NewHttpPost(Constants.UserAuthinticationAdvance, params, options);
}
export function forGotusername(MobileType, UserIPAddress, NIN, Mobile, options = { withCredentials: true }) {
    const params = {
        MobileType: MobileType,
        UserIPAddress: UserIPAddress,
        NIN: NIN,
        ID: "",
        Mobile: Mobile,
        Email: "",
        RequestType: "",
    };
    return NewHttpPost(Constants.ForGotUsername, params, options);
}
export function UserAuthinticationIPOQuickSell(MobileType, UserIPAddress, NIN, ID, Mobile, Email, RequestType, options = { withCredentials: true }) {
    const params = {
        MobileType: MobileType,
        UserIPAddress: UserIPAddress,
        NIN: NIN,
        ID: ID,
        Mobile: Mobile,
        Email: Email,
        RequestType: RequestType,
    };
    return NewHttpPost(Constants.UserAuthinticationIPOQuickSell, params, options);
}

export function resetUserNameAdvance(
    MobileType,
    NIN,
    ID,
    NewUser,
    UserIPAddress,
    UserName,
    options = { withCredentials: true }
) {
    const params = {
        MobileType: MobileType, // "IOS"
        NIN: NIN, // -> entered in first page
        ID: ID, // -> entered in first page
        NewUser: NewUser, // -> enter by user
        UserIPAddress: UserIPAddress,
        UserName: UserName, // -> Old user, from preview api
    };
    return NewHttpPost(Constants.ResetUserNameAdvance, params, options);
}

export function resetPasswordAdvance(
    Mobile,
    Email,
    Password,
    OldPassword,
    MobileType,
    UserIPAddress,
    RequestType,
    UserName,
    NIN,
    ID,
    options = { withCredentials: true }
) {
    const params = {
        Mobile: Mobile, // -> remplir if Shuaa
        Email: Email, // -> remplir if Shuaa
        Password: Password, // new password
        OldPassword: OldPassword,
        MobileType: MobileType,
        UserIPAddress: UserIPAddress,
        RequestType: RequestType,
        UserName: UserName,
        NIN: NIN,
        ID: ID,
    };
    return NewHttpPost(Constants.ResetPasswordAdvance, params, options);
}

export function addProfile(params, thisparam) {
    thisparam.abortController = new window.AbortController();
    let options = {
        withCredentials: true,
        signal: thisparam.abortController.signal,
    };
    return NewHttpPost(Constants.addProfile, params, options);
}

export function updateProfile(params, thisparam) {
    thisparam.abortController = new window.AbortController();
    let options = {
        withCredentials: true,
        signal: thisparam.abortController.signal,
    };
    return NewHttpPost(Constants.updateProfile, params, options);
}
export function TraceInfoPost(params) {
    let options = { withCredentials: true };
    return NewHttpPost(Constants.TraceInfoPost, params, options);
}

export function UpdateUserProfileSettings(params, thisparam) {
    let abortController =
        thisparam === undefined ? new AbortController() : thisparam.abortController;
    let options = { withCredentials: true, signal: abortController.signal };
    return NewHttpPost(Constants.UpdateUserProfileSettings, params, options);
}

export function addConditionalOrder(params) {
    let options = { withCredentials: true };
    return NewHttpPost(Constants.addConditionalOrder, params, options);
}

export function deleteProfile(params) {
    let options = { withCredentials: true };
    return NewHttpPost(Constants.deleteProfile, params, options);
}

export function addMarketWatchProfileSymbol(url, thisparam) {
    thisparam.abortController = new window.AbortController();
    let options = {
        withCredentials: true,
        signal: thisparam.abortController.signal,
    };
    return NewHttpPost(url, null, options);
}

export function logOff() {

    let options = { withCredentials: true };
    let url =
        Constants.baseURL +
        Constants.logOff +
        "/" +
        localStorage.getItem("WebCode");
    return NewHttpPost(url, null, options);
}

export function deleteMarketWatchProfile(url, thisparam) {
    thisparam.abortController = new window.AbortController();
    let options = {
        withCredentials: true,
        signal: thisparam.abortController.signal,
    };
    return NewHttpPost(url, null, options);
}

export function addMarketWatchProfileName(profileName, thisparam) {
    thisparam.abortController = new window.AbortController();
    let options = {
        withCredentials: true,
        signal: thisparam.abortController.signal,
    };
    let url =
        Constants.addMarketWatchProfileName +
        localStorage.getItem("WebCode") +
        "/" +
        profileName;
    return NewHttpPost(url, null, options);
}
export function updateReadPushNotificationsFlag(url) {
    let options = { withCredentials: true };
    return NewHttpPost(url, null, options);
}

export function deleteAlertByAlertID(url, thisparam) {
    thisparam.abortController = new window.AbortController();
    let options = {
        withCredentials: true,
        signal: thisparam.abortController.signal,
    };
    return NewHttpPost(url, null, options);
}

export function deleteMarketWatchProfileSymbol(url, thisparam) {
    thisparam.abortController = new window.AbortController();
    let options = {
        withCredentials: true,
        signal: thisparam.abortController.signal,
    };
    return NewHttpPost(url, null, options);
}
export function DeleteMarketWatchProfileAllSymbols(
    url,
    ProfileID,
    WebCode,
    thisparam
) {
    thisparam.abortController = new window.AbortController();
    let options = {
        withCredentials: true,
        signal: thisparam.abortController.signal,
    };
    let param = {
        ProfileID: ProfileID,
        WebCode: WebCode,
    };
    return NewHttpPost(url, param, options);
}
export function CancelB2bRequest(url, Reqid, WebCode) {
    let options = { withCredentials: true };
    let param = {
        REQ_ID: Reqid,
        WEB_CODE: WebCode,
    };
    return NewHttpPost(url, param, options);
}
export function CancelEquityTransferRequest(url, Reqid, WebCode) {
    let options = { withCredentials: true };
    let param = {
        REQ_ID: Reqid,
        WEB_CODE: WebCode,
    };
    return NewHttpPost(url, param, options);
}

export function deleteConditionalByID(url) {
    let options = { withCredentials: true };
    return NewHttpPost(url, null, options);
}

export function changesPassword(params) {
    let options = { withCredentials: true };
    let url = Constants.baseURL + Constants.changesPassword;
    return NewHttpPost(url, params, options);
}

export function addAlert(url) {
    let options = { withCredentials: true };
    return NewHttpPost(url, null, options);
}

export function getBankTransferInfo(url) {
    let options = { withCredentials: true };
    return NewHttpPost(url, null, options);
}

export function getAccountTransferInfo(params) {
    let options = { withCredentials: true };
    let url = Constants.getAccountTransferInfo;
    return NewHttpPost(url, params, options);
}
export function callAddBankIBAN(params) {
    let options = { withCredentials: true };
    let url = Constants.AddBankIBAN;
    return NewHttpPost(url, params, options);
}

export function callDeleteBasketOrder(params, OrderID) {
    let options = { withCredentials: true };
    let url =
        Constants.DeleteBasketOrder +
        "/" +
        OrderID +
        "/" +
        localStorage.getItem("WebCode");
    return NewHttpPost(url, params, options);
}
export function transferAmountSec(params) {
    let options = { withCredentials: true };
    let url = Constants.transferAmountSec;
    return NewHttpPost(url, params, options);
}

export function submitCrmRequestRamz(params) {
    let options = { withCredentials: true };
    let url = Constants.submitCrmRequestRamz2;
    return NewHttpPost(url, params, options);
}

export function addBasketOrderDetails(params) {
    let options = { withCredentials: true };
    let url = Constants.addBasketOrderDetails;
    return NewHttpPost(url, params, options);
}

export function ModifyBasketOrderDetails(params) {
    let options = { withCredentials: true };
    let url = Constants.modifyBasketOrderDetails;
    return NewHttpPost(url, params, options);
}
export function renewSubscriptionUser(url) {
    let options = { withCredentials: true };
    return NewHttpPost(url, null, options);
}

export function GenerateReports(url, params) {
    let options = { withCredentials: true, responseType: "arraybuffer" };
    return NewHttpPostfile(url, params, options);
}

export function TransferAmount(params) {
    let options = { withCredentials: true };
    let url = Constants.TransferAmount;
    return NewHttpPost(url, params, options);
}




//MARK: GET methods
export async function getAlerts(webcode, thisparam) {
    thisparam.abortController = new window.AbortController();
    let options = {
        withCredentials: true,
        signal: thisparam.abortController.signal,
    };
    let get_alert_url = Constants.getAlerts + webcode;
    return await NewHttpGet(get_alert_url, options);
}
export async function GetTransferReqPenddingShares(url) {
    let options = { withCredentials: true };
    return await NewHttpGet(url, options);
}

export async function getAllPushNotificationsByUser() {
    let options = { withCredentials: true };
    let url =
        Constants.getAllPushNotificationsByUser + localStorage.getItem("WebCode");
    return await NewHttpGet(url, options);
}

export async function getAllPushNotificationsByFirebase(
    Tokenid,
    googleId,
    Title,
    Body,
    Tag,
    isNew
) {
    let options = { withCredentials: true };
    let url =
        Constants.getAllPushNotificationsFromFirebase +
        localStorage.getItem("WebCode") +
        "/" +
        Tokenid +
        "/" +
        googleId +
        "/" +
        Title.trim() +
        "/" +
        Body.trim() +
        "/" +
        Tag.trim() +
        "/" +
        isNew.trim();
    //console.log("urlNOT", url)
    // let url = Constants.getAllPushNotificationsByFirebase + localStorage.getItem("WebCode") + '/Tokenid/googleId/Title/Body/Tag/N';
    return await NewHttpGet(url, options);
}

export async function getExpectedProfitLoss(url) {

    let options = { withCredentials: true };
    return await NewHttpGet(url, options);
}
export async function getPortfolioAndAccSum(url) {

    let options = { withCredentials: true };
    return await NewHttpGet(url, options);
}

export async function getTradeConfirmation(url) {
    let options = { withCredentials: true };
    return await NewHttpGet(url, options);
}

export async function getStatmentOfAccount(url) {
    let options = { withCredentials: true };
    return await NewHttpGet(url, options);
}

export async function sendDocumentByEmail(url) {
    let options = { withCredentials: true };
    return await NewHttpGet(url, options);
}

export async function getMarketByProfile(url, thisparam) {
    thisparam.abortController = new window.AbortController();
    let options = {
        withCredentials: true,
        signal: thisparam.abortController.signal,
    };
    return await NewHttpGet(url, options);
}
export async function getMarketWatchByProfileIDAndSymbol(url, thisparam) {
    thisparam.abortController = new window.AbortController();
    let options = {
        withCredentials: true,
        signal: thisparam.abortController.signal,
    };
    return await NewHttpGet(url, options);
}

export async function calculatesShares(url) {
    let options = { withCredentials: true };
    return await NewHttpGet(url, options);
}

export async function getProfiles(thisparam) {
    thisparam.abortController = new window.AbortController();
    let options = {
        withCredentials: true,
        signal: thisparam.abortController.signal,
    };
    let url = Constants.getProfiles + localStorage.getItem("WebCode");
    return await NewHttpGet(url, options);
}

export async function getConditionalByUsr() {
    let options = { withCredentials: true };
    let url = Constants.getConditionalByUsr + localStorage.getItem("WebCode");
    return await NewHttpGet(url, options);
}

export async function getLookups() {
    let options = { withCredentials: true };
    let url =
        Constants.getLookups +
        localStorage.getItem("WebCode") +
        "?" +
        Math.random();
    return await NewHttpGet(url, options);
}

export async function getUserAccounts() {
    let url = Constants.GetUserAccounts + localStorage.getItem("WebCode");
    let options = { withCredentials: true };
    return await NewHttpGet(url, options);
}

export async function getCompaniesLookups() {
    let url =
        Constants.getCompaniesLookups +
        localStorage.getItem("WebCode") +
        "?" +
        Math.random();
    let options = { withCredentials: true };
    return await NewHttpGet(url, options);
}
export async function GetUSCompaniesResults(symbol) {
    let url =
        Constants.GetUSCompaniesResults +
        symbol +
        "/" +
        localStorage.getItem("WebCode");
    let options = { withCredentials: true };
    return await NewHttpGet(url, options);
}
export async function GetCryptoCompaniesResults(symbol) {
    let url =
        Constants.GetCryptoCompaniesResults +
        symbol +
        "/" +
        localStorage.getItem("WebCode");
    let options = { withCredentials: true };
    return await NewHttpGet(url, options);
}
export async function CheckIfUSSymbolExist(symbol) {
    let url =
        Constants.CheckIfUSSymbolExist +
        localStorage.getItem("WebCode") +
        "/" +
        symbol;
    let options = { withCredentials: true };
    return await NewHttpGet(url, options);
}
export async function CheckIfCryptoSymbolExist(symbol) {
    let url =
        Constants.CheckIfCryptoSymbolExist +
        localStorage.getItem("WebCode") +
        "/" +
        symbol;
    let options = { withCredentials: true };
    return await NewHttpGet(url, options);
}
export async function AddUSTOCompaniesLookups(url) {
    let options = { withCredentials: true };
    return await NewHttpGet(url, options);
}
export async function AddCryptoSymbolTOCompaniesLookups(url) {
    let options = { withCredentials: true };
    return await NewHttpGet(url, options);
}
export async function getProfilesByUserId(thisparam) {
    thisparam.abortController = new window.AbortController();
    let url = Constants.getProfilesByUserId + localStorage.getItem("WebCode");
    let options = {
        withCredentials: true,
        signal: thisparam.abortController.signal,
    };
    return await NewHttpGet(url, options);
}
export async function getCashDepURL(thisparam, themeOfSys, lang) {
    thisparam.abortController = new window.AbortController();

    let url =
        Constants.GetCashDepURL +
        themeOfSys +
        "/" +
        lang +
        "/" +
        localStorage.getItem("WebCode");
    let options = {
        withCredentials: true,
        signal: thisparam.abortController.signal,
    };
    return await NewHttpGet(url, options);
}

export async function GetIPOLink(thisparam, themeOfSys, lang) {
    thisparam.abortController = new window.AbortController();

    let url =
        Constants.GetIPOLink +
        themeOfSys +
        "/" +
        lang +
        "/" +
        localStorage.getItem("WebCode");
    let options = {
        withCredentials: true,
        signal: thisparam.abortController.signal,
    };
    return await NewHttpGet(url, options);
}
export async function UpdateTermsAndConditionsVersion(thisparam) {
    thisparam.abortController = new window.AbortController();

    let url = Constants.UpdateTermsAndConditionsVersion + localStorage.getItem("WebCode");
    let options = {
        withCredentials: true,
        signal: thisparam.abortController.signal,
    };
    return await NewHttpGet(url, options);
}
export async function GetTermsAndConditionsText(appLang) {
   
    let url = Constants.GetTermsAndConditionsText + appLang;
    let options = {
        withCredentials: true
    };
    return await NewHttpGet(url, options);
}

export async function GetDeviceConfigs() {
    let url = Constants.GetDeviceConfigs;
    let options = { withCredentials: true };
    return await NewHttpGet(url, options);
}

export async function GetSettingWorkSpaceByUserID() {
    let url =
        Constants.GetSettingWorkSpaceByUserID + localStorage.getItem("WebCode");
    let options = { withCredentials: true };
    return await NewHttpGet(url, options);
}

export async function getRiskManagement(url, options) {
    return await NewHttpGet(url, options);
}
export async function GetRiskManagment(obj, thisparam) {
    const params = obj;
    thisparam.abortController = new window.AbortController();
    let options = {
        withCredentials: true,
        signal: thisparam.abortController.signal,
    };
    let url = Constants.GetRiskManagment;
    return NewHttpPost(url, params, options);
    // let url = Constants.GetRiskManagment
    // return await NewHttpGet(url, options);
}

export async function GetRiskManagmentCash(obj, thisparam) {
    const params = obj;
    thisparam.abortController = new window.AbortController();
    let options = {
        withCredentials: true,
        signal: thisparam.abortController.signal,
    };
    let url = Constants.GetRiskManagmentCash;
    return NewHttpPost(url, params, options);
    // let url = Constants.GetRiskManagment
    // return await NewHttpGet(url, options);
}

export async function getAvgIndexes(excangeID, day, sector) {
    let options = { withCredentials: true };
    let url =
        Constants.GetAvgIndexes +
        excangeID +
        "/" +
        day +
        "/" +
        sector +
        "/" +
        localStorage.getItem("WebCode");
    //console.log("GetAvgIndexes", url)
    // let url = Constants.getAllPushNotificationsByFirebase + localStorage.getItem("WebCode") + '/Tokenid/googleId/Title/Body/Tag/N';
    return await NewHttpGet(url, options);
}
export async function getContactInfo() {
    let options = { withCredentials: true };
    let url = Constants.GetContactInfo;

    return await NewHttpGet(url, options);
}
export async function getIpAddress() {
    let options = { withCredentials: false };
    let url = "https://geolocation-db.com/json/";
    return await NewHttpGet(url, options);
}

export async function getAllMarketNews() {
    let url =
        Constants.profileBaseUrl +
        Constants.getAllMarketNews +
        localStorage.getItem("WebCode");
    let options = { withCredentials: true };
    return await NewHttpGet(url, options);
}

export async function getHistorySymbolData(url) {
    let options = { withCredentials: true };
    return await NewHttpGet(url, options);
}

export async function getGetProfiles() {
    let url = Constants.getProfiles + localStorage.getItem("WebCode");
    let options = { withCredentials: true };
    return await NewHttpGet(url, options);
}
export async function getBankIBAN(url) {
    let options = { withCredentials: true };
    return await NewHttpGet(url, options);
}
export async function CallCheckIBAN(url) {
    let options = { withCredentials: true };
    return await NewHttpGet(url, options);
}
export async function getAllTransfersReq(url) {
    let options = { withCredentials: true };
    return await NewHttpGet(url, options);
}
export async function getShareTransferLogWithDetails(url) {
    let options = { withCredentials: true };
    return await NewHttpGet(url, options);
}
export async function getHeartBeat(abortController) {
    abortController = new window.AbortController();

    let url = Constants.HeartBeat + localStorage.getItem("WebCode");
    let options = { withCredentials: true, signal: abortController.signal };
    return await NewHttpGet(url, options);
}
export async function RenewUserSesssion(abortController) {
    abortController = new window.AbortController();

    let url = Constants.RenewUserSesssion + localStorage.getItem("WebCode");
    let options = { withCredentials: true, signal: abortController.signal };
    return await NewHttpGet(url, options);
}

export async function getBalanceBreakdown(url) {
    let options = { withCredentials: true };
    return await NewHttpGet(url, options);
}

export async function getDFN_StockData(url) {
    let options = { withCredentials: true };
    return await NewHttpGet(url, options);
}

export async function getUserPermissionsByGroupID(url) {
    //let url = Constants.GetUserPermissionsByGroupID ;
    let options = { withCredentials: true };
    return await NewHttpGet(url, options);
}

export async function getPasswordPolicy() {
    let url =
        Constants.getPasswordPolicy +
        localStorage.getItem("WebCode") +
        "?" +
        Math.random();
    let options = { withCredentials: true };
    return await NewHttpGet(url, options);
}

export async function getExchangeSummary(webcode, options) {
    let get_exchange_summary_url =
        Constants.getExchangeSummary + webcode + "?" + Math.random();
    return await NewHttpGet(get_exchange_summary_url, options);
}

export async function GetRequiredUserDocuments2(
    webcode,
    MainClientID,
    options
) {
    let CheckUpdateIdValidity =
        Constants.GetRequiredUserDocuments2 + "/" + webcode + "/" + MainClientID;
    return await NewHttpGet(CheckUpdateIdValidity, options);
}

export async function CheckUpdateIdValidity(webcode, options) {
    let CheckUpdateIdValidity = Constants.CheckUpdateIdValidity + webcode;
    return await NewHttpGet(CheckUpdateIdValidity, options);
}

export async function getAnalysisIndecator(url) {
    let options = { withCredentials: true };
    return await NewHttpGet(url, options);
}

export async function getBasketOrders(url) {
    let options = { withCredentials: true };
    return await NewHttpGet(url, options);
}

export async function getCustodiansByClientID(url) {
    let options = { withCredentials: true };
    return await NewHttpGet(url, options);
}

export async function GetBasketOrderDetails(url) {
    let options = { withCredentials: true };
    return await NewHttpGet(url, options);
}

export async function UpdatePreferredLangAccount(url) {
    let options = { withCredentials: true };
    return await NewHttpGet(url, options);
}

export function encryptedString(value) {
    var svalue = encode(value, "s");
    var bvalue = encode(svalue[0], "b");
    var gen = generate(3);
    value = bvalue[0] + gen + svalue[1];
    return value;
}

function _utf8_encode(string) {
    string = string.replace(/\r\n/g, "\n");
    var utftext = "";

    for (var n = 0; n < string.length; n++) {
        var c = string.charCodeAt(n);
        if (c < 128) {
            utftext += String.fromCharCode(c);
        } else if (c > 127 && c < 2048) {
            utftext += String.fromCharCode((c >> 6) | 192);
            utftext += String.fromCharCode((c & 63) | 128);
        } else {
            utftext += String.fromCharCode((c >> 12) | 224);
            utftext += String.fromCharCode(((c >> 6) & 63) | 128);
            utftext += String.fromCharCode((c & 63) | 128);
        }
    }
    return utftext;
}

export async function GetDailyReports(url) {
    let options = { withCredentials: true };
    return await NewHttpGet(url, options);
}


function generate(n) {
    var add = 1,
        max = 12 - add; // 12 is the min safe number Math.random() can generate without it starting to pad the end with zeros.

    if (n > max) {
        return generate(max) + generate(n - max);
    }

    max = Math.pow(10, n + add);
    var min = max / 10; // Math.pow(10, n) basically
    var number = Math.floor(Math.random() * (max - min + 1)) + min;

    return "!" + ("" + number).substring(add);
}

function encode(input, type) {
    var output = "";
    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;

    var i = 0;
    if (type === "b") input = _utf8_encode("**" + input);
    else input = _utf8_encode(input);
    while (i < input.length) {
        chr1 = input.charCodeAt(i++);
        chr2 = input.charCodeAt(i++);
        chr3 = input.charCodeAt(i++);
        enc1 = chr1 >> 2;
        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
        enc4 = chr3 & 63;
        if (isNaN(chr2)) {
            enc3 = enc4 = 64;
        } else if (isNaN(chr3)) {
            enc4 = 64;
        }

        output =
            output +
            _keyStr.charAt(enc1) +
            _keyStr.charAt(enc2) +
            _keyStr.charAt(enc3) +
            _keyStr.charAt(enc4);
    }
    var retValue = [];
    if (type === "b") {
        retValue[0] =
            output + Math.floor(Math.random() * 10) + Math.floor(Math.random() * 10);
        retValue[1] = "";

        return retValue;
    } else {
        retValue[1] = output.substring(0, output.length / 2); //key

        output = output.substring(output.length / 2, output.length);

        retValue[0] = output;

        return retValue;
    }
}

export async function NewHttpPost(url, params, options) {
    let postRequest = await axios.post(url, params, options).catch((err) => {

        console.log(url);
        console.log(err);
        responseProcess(err.response.status);
    });
    return postRequest;
}
export async function NewHttpPostfile(url, params, options) {
    let postRequest = await axios.post(url, params, options).catch((err) => {

        responseProcess(err.response.status);
    });
    return postRequest;
}

export function SubmitShareTransferReq(
    params,
    options = { withCredentials: true }
) {
    // const params = {
    //     "USR_CODE": WebCode,
    //     "REQUEST_ID": REQUEST_ID,
    //     "SEQ_REQ_ID": SEQ_REQ_ID,
    //     "REQ_DATE_STR": REQ_DATE_STR,
    //     "REQ_TYPE": REQ_TYPE,
    //     "MAIN_CLIENT_ID": MAIN_CLIENT_ID,
    //     "FROM_ACC": FROM_ACC,
    //     "TO_ACC": TO_ACC,
    //     "FROM_ACC_TYPE": FROM_ACC_TYPE,
    //     "TO_ACC_TYPE": TO_ACC_TYPE,
    //     "M_CODE": M_CODE,
    //     "COMP_ID": COMP_ID,
    //     "QTY": QTY,
    //     "CLOSE_PRICE": CLOSE_PRICE,
    // };

    return NewHttpPost(Constants.SubmitShareTransferReq, params, options);
}
export function SubmitEquityTransferReq(
    params,
    options = { withCredentials: true }
) {
    return NewHttpPost(Constants.SubmitEquityTransferReq, params, options);
}
export function GetAccountTransferInfo(
    params,
    options = { withCredentials: true }
) {
    return NewHttpPost(Constants.GetAccountTransferInfo, params, options);
}
export function UpdateIdValidity(params, options = { withCredentials: true }) {
    return NewHttpPost(Constants.UpdateIdValidity, params, options);
}
export function UploadClientDocuments(
    params,
    options = { withCredentials: true }
) {
    return NewHttpPost(Constants.UploadClientDocuments, params, options);
}

export async function NewHttpGet(url, options) {
    let getRequest = await axios.get(url, options).catch((err) => {

        responseProcess(err.response.status);
    });

    return getRequest;
}

export async function responseProcess(resStatus, isFirstTime = false) {

    switch (resStatus) {
        case 200:
            return true;
        case 201:
            break;
        case 400:
            //console.log("something wen wrong");
            break;
        case 408:

            errorHandling(isFirstTime);
            break;
        case 401:

            errorHandling(isFirstTime);
            break;
        case 500:
            //console.log('server error, try again');
            break;
        default:
            //console.log('unhandled error code: ', resStatus);
            break;
    }
    return false;
}

function errorHandling(isFirstTime) {
    if (isFirstTime) window.appComponent.redirectFunctionality();
    else window.appComponent.errorHandling();
}

export function dateFromStringDateOnly(s) {
    var r = /\d*(\d{2})(\d{2})(\d{4})(\d{2})(\d{2})(\d{2})/.exec(s);
    //alert(r)

    if (r && r.length === 7) {
        let datestring = r[1] + "/" + r[2] + "/" + r[3];
        return datestring;
    }
    return dateFromStringPlanB(s);
}
export function dateFromString(s) {
    var r = /\d*(\d{2})(\d{2})(\d{4})(\d{2})(\d{2})(\d{2})/.exec(s);
    //alert(r)

    if (r && r.length === 7) {
        return new Date(
            parseInt(r[3]),
            parseInt(r[2]) - 1,
            parseInt(r[1]),
            parseInt(r[4]),
            parseInt(r[5]),
            parseInt(r[6])
        );
    }
    return dateFromStringPlanB(s);
}
export function TimeStamptodate(s) {
    var fixstring = s.replace("/Date(", "").replace(")/", "");
    let unix_timestamp = fixstring.substring(0, 10);
    // Create a new JavaScript Date object based on the timestamp
    // multiplied by 1000 so that the argument is in milliseconds, not seconds.
    var date = new Date(unix_timestamp * 1000).toLocaleString();
    // // Hours part from the timestamp
    // var hours = date.getHours();
    // // Minutes part from the timestamp
    // var minutes = "0" + date.getMinutes();
    // // Seconds part from the timestamp
    // var seconds = "0" + date.getSeconds();

    // // Will display time in 10:30:23 format
    // var formattedTime =date.getFullYear().toString() +date.getMonth.toString() + date.getDay.toString() + " " +  hours + ':' + minutes.substr(-2) + ':' + seconds.substr(-2);

    // var r = /\d*(\d{2})(\d{2})(\d{4})(\d{2})(\d{2})(\d{2})/.exec(s);
    // //alert(r)

    // if (r && r.length === 7) {

    //     return new Date(parseInt(r[3]), parseInt(r[2]) - 1, parseInt(r[1]), parseInt(r[4]), parseInt(r[5]), parseInt(r[6]));
    // }
    return date;
}
export async function getMarketIndices(
    exchange_id,
    webcode,
    options = { withCredentials: true }
) {
    let get_market_indices_url =
        Constants.GetMarketIndicies + exchange_id + "/" + webcode;
    //console.log(get_market_indices_url);
    return await NewHttpGet(get_market_indices_url, options);
}

export async function getMarketIndicesVer2(
    exchange_id,
    webcode,
    options = { withCredentials: true }
) {
    let get_market_indices_url =
        Constants.getIndexesSummary + exchange_id + "/" + webcode;
    //console.log(get_market_indices_url);
    return await NewHttpGet(get_market_indices_url, options);
}

export async function getAccountSummary(url, thisparam) {
    var options = { withCredentials: true };
    return await NewHttpGet(url, options);
}

export async function getTransactionSummary(
    url,
    options = { withCredentials: true }
) {
    return await NewHttpGet(url, options);
}

export function dateFromStringPlanB(s) {
    try {
        var strMod = s.replace(/\ /gi, "");
        strMod = strMod.replace(/\:/gi, "");
        strMod = strMod.replace(/\-/gi, "");
        var r = /\d*(\d{2})(\d{2})(\d{4})(\d{2})(\d{2})(\d{2})/.exec(strMod);
        //alert("planb",r)
        if (r && r.length === 7) {
            return new Date(
                parseInt(r[3]),
                parseInt(r[2]) - 1,
                parseInt(r[1]),
                parseInt(r[4]),
                parseInt(r[5]),
                parseInt(r[6])
            );
        }
    } catch (e) {
        console.error(e);
    }
    return new Date(); //ragheb  //ragheb //nbo ETRADE-11
}

// Shared Transfer Services
export async function GetShareTransferLogGrouped(
    WebCode,
    MainClientID,
    options = { withCredentials: true }
) {
    let get_sharer_transfer_log_grouped_url =
        Constants.GetShareTransferLogGrouped + "-1/" + WebCode + "/" + MainClientID;
    //console.log(get_sharer_transfer_log_grouped_url);
    return await NewHttpGet(get_sharer_transfer_log_grouped_url, options);
}

export async function GetNextRequestID(
    webcode,
    options = { withCredentials: true }
) {
    let get_next_request_id_url = Constants.GetNextRequestID + webcode;
    //console.log(get_next_request_id_url);
    return await NewHttpGet(get_next_request_id_url, options);
}

//Account portfolio Service
export async function GetExpectedProfitLossSec(
    MainClientID,
    ClientID,
    WebCode,
    Date,
    BrokerID,
    ExchangeID,
    options = { withCredentials: true }
) {
    let get_expectedprofitlosssec_url =
        Constants.GetExpectedProfitLossSec +
        MainClientID +
        "/" +
        ClientID +
        "/" +
        WebCode +
        "/" +
        Date +
        "/" +
        BrokerID +
        "/" +
        ExchangeID;
    //console.log("URLGetExpectedProfitLossSec", get_expectedprofitlosssec_url);
    return await NewHttpGet(get_expectedprofitlosssec_url, options);
}

// //chatbot
export async function GetChatWebBRKLookup(WebCode) {
    let getchatbotwebbrklookup_url = Constants.getChatWebBRKLookup + WebCode;
    //console.log("chatbot_url", getchatbotwebbrklookup_url);
    let options = { withCredentials: true };
    return await NewHttpGet(getchatbotwebbrklookup_url, options);
}

export async function GetLastChatConversion(WebCode, BRKID, dateFrom, DateTo) {
    let getLastChatConversion =
        Constants.getLastChatConversion +
        WebCode +
        "/" +
        BRKID +
        "/" +
        dateFrom +
        "/" +
        DateTo;
    //console.log("GetLastChatConversion", getLastChatConversion);
    let options = { withCredentials: true };
    return await NewHttpGet(getLastChatConversion, options);
}
export async function GetUSSymbolNews(Symbol, WebCode) {
    let getLastChatConversion =
        Constants.GetUSSymbolNews + Symbol + "/" + WebCode;
    //console.log("GetLastChatConversion", getLastChatConversion);
    let options = { withCredentials: true };
    return await NewHttpGet(getLastChatConversion, options);
}

export async function gethandleServerTime(url) {
    let options = { withCredentials: true };
    return await NewHttpGet(url, options);
}


//mustafa
export async function GetChartIntraDayData(symbol, exchange, from, to, period, type, WebCode) {
    
    // Construct the URL with the required parameters
    let url = Constants.GetChartIntraDayData 
    + symbol 
    + "/"+
    exchange
    +"/"+
    from+
    "/"+
    to+
    "/"+
    period+
    "/"+
    type+
    "/"+
    WebCode;
    let options = { withCredentials: true };
    return await NewHttpGet(url, options);
}
